export default __webpack_public_path__ + "static/media/hbs-k-cbb-poster-1.548554eb.jpg";